import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import {
  createSelectedItemsSlice,
  type SelectedItemsState,
} from "features/Application/slices/createSelectedItemsSlice";
import { type EmbeddedVideoGroup } from "../types/models";

export interface EmbeddedVideoGroupsState extends SelectedItemsState<EmbeddedVideoGroup> {}

const initialState: EmbeddedVideoGroupsState = {
  items: [],
  itemsCount: 0,
  selectedIds: [],
  isLoading: false,
  error: undefined,
  selectedItems: [],
};

const embeddedVideoGroupsSlice = createSelectedItemsSlice(
  { namespace: ReducerNamespaceTypes.Library, entity: ReducerEntityPrefixTypes.EmbeddedVideos, name: "groups" },
  initialState,
);

export const { fetchBegin, fetchSuccess, fetchFailure, selectedItemsChanged, resetSelectedItems } =
  embeddedVideoGroupsSlice.actions;

export default embeddedVideoGroupsSlice.reducer;
